import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  adminPassword,
  barbersLimitedReservationApiUrl,
  adminUsername,
} from '../../config';

export const deleteShopSlot = async (
  slotId: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedReservationApiUrl}/shop-slots/${slotId}`,
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error deleting shop slot:', error);
    throw error;
  }
};

export const deleteBarberSlot = async (
  slotId: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedReservationApiUrl}/barber-slots/${slotId}`,
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error deleting barber slot:', error);
    throw error;
  }
};

export const deleteBooking = async (
  bookingId: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedReservationApiUrl}/bookings/${bookingId}`,
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error deleting booking:', error);
    throw error;
  }
};
